import React from 'react';
import type { Maybe } from '@soundxyz/utils';
import type { CSSProperties } from '@components-shared/src/stitches';
import type { SharedImageWrapperProps } from '../image/BaseImage';
import { ImageWrapper, SquareImage } from '../image/BaseImage';
import { getPlaceholderAvatarSrc } from './utils';

export function AvatarUI({
  src,
  username,
  size,
  walletAddress,
  webappUriPath,
  priority = false,
  unoptimized = false,
  loading,
  backgroundColor,
  onClick,
  children = null,
  className,
  wrapperClassName,
  ...props
}: {
  src?: string | null;
  username?: string | null;
  webappUriPath: Maybe<`/${string}`>;
  size: number;
  walletAddress: string;
  priority?: boolean;
  unoptimized?: boolean;
  loading?: 'eager' | 'lazy';
  backgroundColor?: CSSProperties['backgroundColor'];
  onClick?: () => void;
  children?: React.ReactNode;
  hasDarkBorder?: boolean;
  className?: string;
  wrapperClassName?: string;
} & SharedImageWrapperProps) {
  const {
    hasBorder,
    hasDarkBorder,
    hasShadow,
    scaleOnHover = false,
    borderRadius = '25%',
    disableLink,
  } = props;

  const defaultBkg = src ? 'unset' : '$black';
  const background = backgroundColor || defaultBkg;
  return (
    <div className="relative">
      <ImageWrapper
        href={webappUriPath}
        disableLink={disableLink}
        hasShadow={!!hasShadow}
        hasBorder={!!hasBorder}
        hasDarkBorder={!!hasDarkBorder}
        borderRadius={borderRadius}
        onClickEffect={onClick}
        scaleOnHover={scaleOnHover}
        css={{
          backgroundColor: background,
        }}
        className={wrapperClassName}
      >
        <SquareImage
          src={src || getPlaceholderAvatarSrc({ walletAddress })}
          size={size}
          alt={username || 'avatar-img'}
          priority={priority}
          borderRadius={borderRadius}
          unoptimized={unoptimized}
          loading={loading}
          className={className}
        />
      </ImageWrapper>
      {children}
    </div>
  );
}
